/**
 * ProgressButton React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';

// Material UI components
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';


function ProgressButton(props) {
    if (props.busy) {
        return <Button
            className={props.className}
            variant="outlined"
            disabled={true}
            fullWidth={true}
        >
            <CircularProgress size={24} />
        </Button>;
    }
    else {
        return <Button
            className={props.className}
            variant="outlined"
            disabled={props.disabled}
            onClick={props.onClick}
            fullWidth={true}
        >{props.children}</Button>;
    }
}

export default ProgressButton;